import { render, staticRenderFns } from "./ModalTeacherInput.vue?vue&type=template&id=4c2e19df&scoped=true&lang=pug&"
import script from "./ModalTeacherInput.vue?vue&type=script&lang=ts&"
export * from "./ModalTeacherInput.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTeacherInput.vue?vue&type=style&index=0&id=4c2e19df&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e19df",
  null
  
)

export default component.exports